import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Cont',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Gestionați contul',
      description: 'Mențineți contul actualizat și gestionați setările.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Metode de plată',
      description: 'Adăugați, schimbați sau selectați metoda de plată preferată.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Ajutor și întrebări frecvente',
    },
    [AccountItemEnum.Logout]: {
      title: 'Deconectați-vă',
    },
    [AccountItemEnum.Language]: {
      title: 'Limbă',
    },
  },
};
